import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { WebConfigDashService } from '../../../../shared/services/webConfigDash.service';
import { FormControl, Validators } from '@angular/forms';
import { WebListaAtasService } from 'app/main/content/shared/services/webListaAtas.service';
import { WebConfigFuncionalidadeRotinaService } from 'app/main/content/shared/services/webConfigFuncionalidadeRotina.service';
import { WebIntegrFuncionalidadeADOService } from 'app/main/content/shared/services/webIntegrFuncionalidadeADO.service';
import { PlanoService } from 'app/main/content/shared/services/plano.service';
import { WebIntegrPerfilADOService } from 'app/main/content/shared/services/webIntegrPerfilADO.service';
import { Plano } from 'app/main/content/shared/models/plano.model';
import { WebIntegrPerfilADO } from 'app/main/content/shared/models/webIntegrPerfilADO.model';
import { WebIntegrFuncionalidadeADO } from 'app/main/content/shared/models/webIntegrFuncionalidadeADO.model';

@Component({
  selector: 'app-edit.dialog',
  templateUrl: '../../dialogs/edit/edit.dialog.html',
  styleUrls: ['../../dialogs/edit/edit.dialog.scss']
})
export class EditDialogMensagemFuncionalidadeComponent {

    listaPlano: Plano[] = [];
    listaPerfil: WebIntegrPerfilADO[] = [];
    listaFuncionalidade: WebIntegrFuncionalidadeADO[] = [];
  constructor(public dialogRef: MatDialogRef<EditDialogMensagemFuncionalidadeComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public webConfigFuncionalidadeRotinaService: WebConfigFuncionalidadeRotinaService,
              private webIntegrFuncionalidadeADOService : WebIntegrFuncionalidadeADOService,
              private planoService: PlanoService,
              private webIntegrPerfilADOService: WebIntegrPerfilADOService) { }

  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);
  ngOnInit() {
    this.planoService.getAll().subscribe(obj => this.listaPlano = obj);
    this.webIntegrPerfilADOService.getAll().subscribe(obj => this.listaPerfil = obj);
    this.webIntegrFuncionalidadeADOService.getAll().subscribe(obj => this.listaFuncionalidade = obj);
  }
  getErrorMessage() {
    return this.formControl.hasError('required') ? 'Required field' :
      this.formControl.hasError('email') ? 'Not a valid email' :
        '';
  }

  submit() {
    // emppty stuff
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  stopEdit(): void {
    this.webConfigFuncionalidadeRotinaService.listUpdateData(this.data);
  }
}